import { Component, OnDestroy, OnInit } from '@angular/core';
import { BroadcastService, EditableConfigGridData, ToasterType } from '@cv-invision/core';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LenderService } from '../../service/lender.service';
import { GlobalConfigurationState } from '../../state/global-configuration.state';
import { BranchModel, DefaultSettingsModel } from './model/nexsys-default-setting.model';
import { NexsysDefaultSettingService } from './service/nexsys-default-setting.service';

@Component({
	selector: 'cv-invision-nexsys-default-setting',
	templateUrl: './nexsys-default-setting.component.html',
	styleUrls: ['./nexsys-default-setting.component.scss']
})
export class NexsysDefaultSettingComponent implements OnInit, OnDestroy {
	public acuityBranchSelected: Array<any>;
	public cmpAcuityBranchSelected: Array<any>;
	public acuityLenderBranchesList: Array<BranchModel>;
	public cmpAcuityLenderBranchesList: Array<BranchModel>;
	public defaultConfigModel: DefaultSettingsModel;
	public optionsReady: boolean;
	saving: boolean;
	isDirtyForm: boolean;

	private atComponentDestroy = new Subject();

	constructor(
		private store: Store,
		private broadcastService: BroadcastService,
		private nexsysDefaultSettingService: NexsysDefaultSettingService,
		public lenderService: LenderService
	) {
		this.defaultConfigModel = new DefaultSettingsModel();
		this.acuityLenderBranchesList = this.store.selectSnapshot(GlobalConfigurationState.getAcuityLenderBranches);
		this.cmpAcuityLenderBranchesList = this.store.selectSnapshot(GlobalConfigurationState.getCmpAcuityLenderBranches);
		this.acuityBranchSelected = [];
		this.cmpAcuityBranchSelected = [];
	}

	async ngOnInit(): Promise<void> {
		this.nexsysDefaultSettingService.setFormData({ isDirty: true });
		await this.nexsysDefaultSettingService
				.getNexsysDefaultSettings()
				.toPromise()
				.then(result => {
					this.defaultConfigModel = result;
					if (result.defaultBranchId) {
						this.acuityBranchSelected = this.acuityLenderBranchesList.filter(
							b => b.id === this.defaultConfigModel.defaultBranchId
						);
					}

					if (result.defaultCMPBranchId) {
						this.lenderService.getCmpAcuityLenderBranches(result.defaultCMPBranchName)
							.pipe(takeUntil(this.atComponentDestroy))
							.subscribe((response : any) => {
								this.cmpAcuityLenderBranchesList = response;

								this.cmpAcuityBranchSelected = this.cmpAcuityLenderBranchesList.filter(
									b => b.id === this.defaultConfigModel.defaultCMPBranchId
								);
							})
					}

					this.optionsReady = true;
				});

		// listen to valutrust property types config editor
		this.nexsysDefaultSettingService
			.getFormDataListener()
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((result: EditableConfigGridData) => {
				if (result.doSave !== undefined && result.doSave) {
					this.onSave();
				}

				if (result.isDirty !== undefined) {
					this.isDirtyForm = result.isDirty;
				}
				if (result.saving !== undefined) {
					this.saving = result.saving;
				}
			});
	}

	/**
	 * On save grid config.
	 */
	onSave(): void {
		this.nexsysDefaultSettingService
			.saveNexsysDefaultSettings(this.defaultConfigModel)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				result => {
					if (result && result.succeeded) {
						this.broadcastService.broadcast({
							name: ToasterType.SUCCESS,
							event: { message: 'Default Settings saved successfully' }
						});
					}
					this.nexsysDefaultSettingService.setFormData({ saving: false, doSave: false });
				},
				error => {
					console.error(error);
					this.broadcastService.broadcast({
						name: ToasterType.ERROR,
						event: { error: 'Error occurred ' + error }
					});
					this.nexsysDefaultSettingService.setFormData({ saving: false, doSave: false });
				}
			);
	}

	/**
	 * on branch selected
	 * @param $event
	 */
	onBranchSelected($event: any, type: string): void {
		if ($event && type) {
			switch (type) {
				case 'acuity':
					this.defaultConfigModel.defaultBranchId = $event?.id || '';
					this.defaultConfigModel.defaultBranchName = $event?.title || '';
					break;
				case 'cmpacuity':
					this.defaultConfigModel.defaultCMPBranchId = $event?.id || '';
					this.defaultConfigModel.defaultCMPBranchName = $event?.title || '';
					break;
			}
		}

	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
